import React from 'react';
import styles from './LoadingAll.module.scss';

type LoadingProps = {
    message?: string;
    show?: boolean;
};

const Loading: React.FC<LoadingProps> = ({ message, show = true }) => {
    if (!show) return null;

    return (
        <div className={styles.siteLoader}>
            <div className={styles.container}>
                <div className={styles.loader} />
            </div>
            {message && <div className={styles.siteLoaderMessage}>{message}</div>}
        </div>
    );
};

export default Loading;
